import React, { useState } from 'react'
import Carousel, { Modal, ModalGateway } from 'react-images'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFText,
  CFView,
  DefaultScreen,
  LocationSelect,
  MobileScreen,
} from 'components'
import { heroText, logoTitle, viewMenu } from 'images'
import { dispatch } from 'store'

const orderingUrl =
  process.env.REACT_APP_ENVIRONMENT === 'dev'
    ? 'https://demo.codefusion.tech/restaurants/ebisu/locations/ebisuLocation1'
    : 'https://order.codefusion.tech/restaurants/z1n6s0Q1U12JBeruNx0e/locations/0nBUuNbz0naRmB9PPMgD'

const images = []

export default () => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <MobileScreen>
        <CFView
          column
          center
          bg="rgb(0,0,0,.8)"
          boxShadow="0 2px 5px rgba(0,0,0,.5)"
          pv="10px"
        >
          <CFView row center>
            <CFImage
              h="75px"
              src={heroText}
              alt="One Sushi Japanese Restaurant Logo"
            />
            <CFImage
              h="30px"
              ml="15px"
              src={logoTitle}
              alt="One Sushi Japanese Restaurant Logo"
              zIndex={98}
            />
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView row justifyStart zIndex={98} w="100%">
          <CFView row justifyBetween alignCenter w="100%" maxWidth="1400px">
            <CFImage
              w="25%"
              mt="2%"
              ml="35px"
              src={heroText}
              alt="One Sushi Japanese Restaurant Logo"
              zIndex={98}
            />
          </CFView>
        </CFView>
      </DefaultScreen>
      <ModalGateway>
        {showModal ? (
          <Modal onClose={() => setShowModal(false)}>
            <Carousel views={images} />
          </Modal>
        ) : null}
      </ModalGateway>
    </>
  )
}
